// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS Component */
.Strong-module__Container__wVKUV {
    font-weight: var(--ds-font-weight-bold);
    font-size: inherit;
}

.Strong-module__BreakAll__ZEQo9 {
    word-break: break-all;
}

.Strong-module__BreakWord__LC0dW {
    overflow-wrap: break-word;
}
/* COLORS */
.Strong-module__DefaultColor__q7ZNd {
    color: var(--ds-font-color);
}

.Strong-module__AccentColor__Ls880 {
    color: var(--ds-font-color-accent);
}

.Strong-module__InvertedColor__B06e8 {
    color: var(--ds-font-color-inverted);
}

.Strong-module__AlertColor__r8TkE {
    color: var(--ds-font-color-alert);
}

.Strong-module__InformativeColor__LKOI7 {
    color: var(--ds-font-color-informative);
}

.Strong-module__PositiveColor__E3geR {
    color: var(--ds-font-color-positive);
}

.Strong-module__NegativeColor__VCUb_ {
    color: var(--ds-font-color-negative);
}

.Strong-module__InheritColor__KLVFJ {
    color: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Strong-module__Container__wVKUV`,
	"BreakAll": `Strong-module__BreakAll__ZEQo9`,
	"BreakWord": `Strong-module__BreakWord__LC0dW`,
	"DefaultColor": `Strong-module__DefaultColor__q7ZNd`,
	"AccentColor": `Strong-module__AccentColor__Ls880`,
	"InvertedColor": `Strong-module__InvertedColor__B06e8`,
	"AlertColor": `Strong-module__AlertColor__r8TkE`,
	"InformativeColor": `Strong-module__InformativeColor__LKOI7`,
	"PositiveColor": `Strong-module__PositiveColor__E3geR`,
	"NegativeColor": `Strong-module__NegativeColor__VCUb_`,
	"InheritColor": `Strong-module__InheritColor__KLVFJ`
};
export default ___CSS_LOADER_EXPORT___;
